import api from "../request/api";
import {
	mapActions
} from "vuex";
export default {
	data() {
		return {
			// 兑换比例
			proportion:null,
			proportionData:[
				{name:'1/2',data:50},
				{name:'1/4',data:25},
				{name:'1/8',data:12.5},
				{name:'包尾',data:100},
			],
			// 获取积分商场首页数据
			luckList: [],
			lotteryList: [],
			// 分类
			menuList: [],
			// 心愿单
			shop_list_cart: [],
			// 收藏列表
			shop_list_collect: [],
			showPosterShare: false,
			wapData: null,
			// 内容
			infoDetail: null,
			// 数量
			cartNum: 1,
			new_state: true,
			// 心愿单立即购买
			luckData: null,
			// 推荐
			dataList: [],
			// 获取的id
			allAddData: [],
			finished: false,
			loading: false,
			getStoreIntegral_pubList: [],
			// 搜索
			search: {
				type: 8,
				cate_id: null,
				salesOrder: null,
				news: null,
				page: 1,
				limit: 20,
			},
			// 中奖人
			BarcoderWinlnfo: null,
			//
			peroidDataB: null,

			// 积分首页兑换显示
			exchange_show: false,
			requestCounter: 0
		};
	},
	watch: {
		cartNum(newv) {
			if (newv > this.exchangeData?.def_renshu) {
				this.cartNum = this.exchangeData?.def_renshu
			}
		},
	},
	methods: {
		...mapActions(["setTimeDown", "setPointsCartCount", "setShopCartCount"]),
		async login() {
			let data = new FormData();
			data.append("account", this.account);
			data.append("password", this.password);
			await api
				.login(data)
				.then((result) => {
					this.$toast(result.msg);
					if (result.status === 200) {
						window.localStorage.setItem("user", JSON.stringify(result.data));
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},
		async getHomeData(data) {
			return api.store_integral.getStoreIntegral(data);
		},
		async getStoreIntegralIndex() {
			return api.store_integral.getStoreIntegralIndex();
		},
		// 获取心愿单列表
		async getLuckList() {
			try {
				await api.store_integral
					.getLuckList()
					.then((result) => {
						if (result.status === 200) {
							this.shop_list_cart = result.data.valid;
							if (result.data.valid.length <= 0) {
								this.getStoreIntegral();
							}
						}
					})
					.catch((err) => {
						throw err;
					});
			} catch (error) {
				console.error(error);
			}
		},
		// 批量加入心愿单
		all_add() {
			var this_ = this;
			try {
				this.$dialog
					.confirm({
						title: `是否全部加入心愿单？`,
						confirmButtonColor: "var(--bg1)",
					})
					.then(async () => {
						const result = await api.store_integral.all_add({
							productId: this.allAddData,
						});
						this_.$toast(result.status === 200 ? "添加成功" : result.msg);
						if (result.status === 200) {
							setTimeout(() => {
								this_.getLuckList();
							}, 1000);
						}
					})
					.catch(() => {
						this.$toast("取消");
					});
			} catch (error) {
				console.error(error);
			}
		},
		// 获取推荐信息
		async getStoreIntegral() {
			try {
				const HomeData = await api.store_integral.getStoreIntegral({
					limit: 4,
				});
				if (HomeData.status === 200) {
					this.dataList = HomeData.data.data;
					HomeData.data.data.forEach((item) => {
						this.allAddData.push(item.sid);
					});
				}
			} catch (error) {
				console.error(error);
			}
		},
		// 设置心愿单
		async setLuckAdd(data) {
			try {
				const result = await api.store_integral.setLuckAdd(data);
				var this_ = this;
				if (result.status === 200) {
					this.$toast({
						message: data.new != 0 ? "换取成功" : "添加心愿单成功",
						duration: 1000,
						onClose: function() {
							this_.getHttpCartCount();
						},
					});
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getHttpCartCount() {
			try {
				if (
					window.localStorage.getItem("user") &&
					window.localStorage.getItem("info")
				) {
					const [carCount, PointsCartCount] = await Promise.all([
						api.cart.getCarCount(),
						api.cart.getLuckCount(),
					]);
					if (PointsCartCount.status == 200) {
						this.setPointsCartCount(PointsCartCount.data.count || null);
					}
					if (carCount.status == 200) {
						this.setShopCartCount(carCount.data.count || null);
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
		// 获取兑换者信息
		async getLuckRecord_s() {
			try {
				const result = await api.store_integral.getLuckRecord(this.LuckRecord);
				if (result.status === 200) {
					// console.log(result);
				}
			} catch (error) {
				console.error(error);
			}
		},
		async addCollect(data) {
			try {
				await api.store_integral
					.setCollect(data)
					.then((result) => {
						if (result.status === 200) {
							this.collect = true;
							this.$toast("添加收藏成功");
						}
					})
					.catch((err) => {
						throw err;
					});
			} catch (error) {
				console.error(error);
			}
		},
		async delCollect(data) {
			var this_ = this;
			try {
				this.$dialog
					.confirm({
						title: `是否取消收藏？`,
						confirmButtonColor: "var(--bg1)",
					})
					.then(async () => {
						const result = await api.store_integral.delCollect({
							id: data
						});
						if (result.status === 200) {
							this_.collect = false;
							const newData = [];
							this_.shop_list_collect.forEach((item) => {
								if (!data.includes(item.pid)) {
									newData.push(item);
								}
							});
							this_.shop_list_collect = newData;
							this_.$toast("取消收藏成功");
						}
					})
					.catch(() => {
						// on cancel
						this.$toast("取消删除");
					});
			} catch (error) {
				console.error(error);
			}
		},
		// 获取最新揭晓
		async get_lottery_list(data) {
			try {
				const result = await api.store_integral.get_lottery_list(data);
				if (result.status === 200) {
					this.lotteryList = result.data.listItems;
				}
			} catch (error) {
				console.error(error);
			}
		},
		// async getIntergral_category() {
		//   try {
		//     const result = await api.store_integral.getIntergral_category();
		//     if (result.status === 200) {
		//       result.data.unshift({
		//         cate_name:'全部',
		//         id:0,
		//       });
		//       this.menuList = result.data;
		//     }
		//   } catch (error) {
		//     console.error(error);
		//   }
		// },
		// 批量加入心愿单
		async setAllAdd(data) {
			try {
				let d = [];
				data.forEach((item) => {
					d.push(item.pid);
				});
				const result = await api.cart.setAllAdd({
					productId: d
				});
				this.$toast(result.status === 200 ? "加入心愿单成功" : result.msg);
			} catch (error) {
				console.error(error);
			}
		},
		// 分类
		async getIntergral_category() {
			return api.store_integral.getIntergral_category();
		},
		async getSpreadBanner() {
			try {
				const result = await api.getSpreadBanner();
				if (result.status == 200) {
					this.wapData = result.data[0];
					this.showPosterShare = true;
				}
			} catch (error) {
				console.error(error);
			}
		},
		// 获取内容
		// 立即换取
		async playLuckAdd(data, obj) {
			try {
				const result = await api.store_integral.setLuckAdd({
					...data,
					cartNum: this.cartNum,
				});
				if (result.status === 200) {
					this.luckData = result.data;
					this.luckConfirm(result.data.cartId);
					this.exchange_show = false;
					// this.$toast(data.new != 1 ? "换取成功" : "添加心愿单成功");
				} else if (result.status === 400) {
					this.cartNum = obj.def_renshu;
				}
			} catch (error) {
				console.error(error);
			}
		},
		// 确定订单order/confirm
		async luckConfirm(data) {
			var this_ = this;
			try {
				const result = await api.store_integral.luckConfirm({
					cartId: data.toString(),
					status: this.new_state == true ? 1 : 0,
				});
				if (result.status === 200) {
					this.luckData = result.data;
					this.$toast({
						message: '成功换取' + this.cartNum + '积分',
						duration: 1000,
						onClose: function() {
							this_.getCart_goods(data.toString() || null, function(data) {
								location.reload()
								if (data.valid[0].productInfo.def_renshu === 0) {
									if (typeof this_.$route.name === 'string' && !this_.$route
										.name.includes('detail')) {
										this_.setTimeDown(true);
									}
								}
							});
						},
					});
					// console.log(result.data.product.valid[0]);
					// this.timeDown = true;
					// if(result.data.time === 0 ){
					//   this.$toast(result.msg);
					// }else{
					//   this.$toast(result.msg);
					// }
				}
			} catch (error) {
				console.error(error);
			}
		},
		async getCart_goods(data, callBack) {
			const result = await api.store_integral.getCart_goods({
				cartId: data || null,
			});
			if (result.status === 200) {
				callBack(result.data);
				// this.data = result.data.product.valid;
			}
		},
		// 加载类型
		async getStoreIntegral_pub(data) {
			try {
				const currentCounter = ++this.requestCounter;
				const HomeData = await api.store_integral.getStoreIntegral({
					...this.search,
					...data,
				});
				if (HomeData.status === 200) {
					if (HomeData.data.data.length <= 0) {
						this.finished = true;
						this.loading = true;
					} else {
						if (currentCounter === this.requestCounter) {
							console.log('处理一次')
							this.search.page++;
							this.loading = false;
							this.getStoreIntegral_pubList = this.getStoreIntegral_pubList.concat(
								HomeData.data.data
							);
							this.allAddData=[];
							HomeData.data.data.forEach((item) => {
								this.allAddData.push(item.sid);
							});
						}
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
		// barcoderWinlnfo 满员获取中奖人
		async getBarcoderWinlnfo(productld) {
			const result = await api.store_integral.barcoderWinlnfo({
				productld
			});
			if (result.status == 200) {
				this.BarcoderWinlnfo = result.data;
			}
		},
		// 收货 
		async delivery(data) {
			var this_ = this;
			try {
				this.$dialog
					.confirm({
						title: `是否确认收货？`,
						confirmButtonColor: "var(--bg1)",
					})
					.then(async () => {
						const result = await api.store_integral.take_delivery(data);
						if (result.status === 200) {
							location.reload()
						} else {
							this_.$toast(result.msg);
						}
					})
					.catch(() => {
						// on cancel
						this.$toast("取消");
					});
			} catch (error) {
				console.error(error);
			}
		},
		// 更改积分
		changeProportion(def_renshu,item){
			// this.cartNum = item.def_renshu
			try {
				console.log(def_renshu * (item.data / 100))
				// 向下取整 math 29.5 就是30
				this.cartNum = Math.ceil(def_renshu * (item.data / 100))
			}catch(e){
				console.log(e)
				this.cartNum = 0
			}
		},
		popup(data) {
			this.$dialog
				.alert({
					title: data.title || "温馨提示",
					confirmButtonColor: data.color || "var(--bg1)",
					message: data.message || "热门商品可能会瞬间抢光哦，此勾选后系统将会自动为您换取最新一件！",
				})
				.then(() => {
					// on close
				});
		},
	},
};
